import { useAtom } from "jotai";
import { Flex, Text } from "src/elements";
import { omniAtom } from "src/utils/atoms";
import { highlightsModeAtom } from "../Planogram/store/atoms";

export interface PlanogramLegend {
  formula: string;
  formulaColorsMap: { [key: string]: string };
}

export const planogramLegendAtom = omniAtom({
  key: "planogram/legend",
  value: { formula: "", formulaColorsMap: {} } as PlanogramLegend,
});

export const PlanogramLegend = () => {
  const [legend] = useAtom(planogramLegendAtom);
  const [highlightsMode] = useAtom(highlightsModeAtom);

  if (!highlightsMode) return null;

  return (
    <Flex width="100%" gap="15px" flexWrap="wrap">
      {Object.entries(legend.formulaColorsMap).map((entry) => (
        <Flex key={entry[0]} flexWrap="nowrap" gap="3px" align="center">
          <Flex minWidth="8px" minHeight="8px" borderRadius="50%" background={entry[1]}></Flex>

          <Text whiteSpace="nowrap">{entry[0].replaceAll('"', "")}</Text>
        </Flex>
      ))}
    </Flex>
  );
};
